import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { UseQueryResult } from 'react-query';
import MlxBlockUI from '../../../../components/common/MlxBlockUI/MlxBlockUI';
import MlxActionIcon from '../../../../components/common/MlxActionIcon/MlxActionIcon';
import { _Feature } from '../../../../helpers/subscriptionFeatureHelper';

type Props = {
    features: _Feature[];
    featureListQuery: UseQueryResult<any, unknown>;
    onEdit: (feature: _Feature) => void;
    currentPage: number;
    rowsPerPage: number;
    totalRecords: number;
    onPageChange: (event: any) => void;
};

function FeaturesList({ features, featureListQuery, onEdit, currentPage, rowsPerPage, totalRecords, onPageChange }: Readonly<Props>) {
    const featureNameTemplate = (rowData: _Feature) => {
        return <span className="feature-name">{rowData.name}</span>;
    };

    const lookupKeyTemplate = (rowData: _Feature) => {
        return (
            <div className="overflow-ellipsis" title={rowData.lookupKey}>
                {rowData.lookupKey}
            </div>
        );
    };

    const descriptionTemplate = (rowData: _Feature) => {
        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{rowData.description || '-'}</div>;
    };

    const scopeTemplate = (rowData: _Feature) => {
        return <span>{rowData.sourceType || '-'}</span>;
    };

    const linkedModuleTemplate = (rowData: _Feature) => {
        return <span>{rowData.sourceModule?.moduleName || '-'}</span>;
    };

    const associatedPlansTemplate = (rowData: _Feature) => {
        const plans = rowData.metadata?.associatedPlans || [];
        if (plans.length === 0) return <span>-</span>;

        return (
            <div className="associated-plans">
                {plans.map((plan: string, index: number) => (
                    <span key={index} className="plan-badge">
                        {plan}
                    </span>
                ))}
            </div>
        );
    };

    const actionTemplate = (rowData: _Feature) => {
        return (
            <div className="d-flex flex-row align-items-center justify-content-end">
                <MlxActionIcon className="action-icon" actionType="EDIT" onClick={() => onEdit(rowData)} />
            </div>
        );
    };

    return (
        <MlxBlockUI isLoading={featureListQuery.isFetching} opacity={0.5}>
            <DataTable
                value={features}
                className="custom-p-table"
                paginator
                lazy
                first={(currentPage - 1) * rowsPerPage}
                rows={rowsPerPage}
                totalRecords={totalRecords}
                onPage={onPageChange}
                rowsPerPageOptions={[5, 10, 25, 50]}
                scrollable
                scrollHeight="flex"
                size="small"
                removableSort
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
                dataKey="id"
                tableStyle={{ minWidth: '90rem' }}
            >
                <Column field="name" header="Feature Name" body={featureNameTemplate} style={{ minWidth: '12rem' }} />
                <Column field="lookupKey" header="Lookup Key" body={lookupKeyTemplate} style={{ minWidth: '12rem' }} />
                {/* <Column field="sourceType" header="Scope" body={scopeTemplate} style={{ minWidth: '10rem' }} /> */}
                <Column field="sourceId" header="Linked Module" body={linkedModuleTemplate} style={{ minWidth: '11rem' }} />
                {/* <Column field="associatedPlans" header="Associated Plans" body={associatedPlansTemplate} style={{ minWidth: '13rem' }} /> */}
                <Column field="featureKey" header="Stripe ID" style={{ minWidth: '9rem' }} />
                <Column
                    field="description"
                    header="Description"
                    body={descriptionTemplate}
                    style={{ minWidth: '15rem', maxWidth: '25rem' }}
                />
                <Column
                    body={actionTemplate}
                    header=""
                    style={{ maxWidth: 'auto', minWidth: '5rem', background: '#f9fafb', textAlign: 'right' }}
                    alignFrozen="right"
                    frozen={true}
                />
            </DataTable>
        </MlxBlockUI>
    );
}

export default FeaturesList;
